import { ActivityEntityName } from './activity.entity.name';
import { AlertPriority } from './label';

export enum AlertType {
    Tag = "Tag",
    LimitExceed = "LimitExceed",
    BlockLimitExceed = "BlockLimitExceed",
    MarginThresholdNotMet = "MarginThresholdNotMet"
}

export interface Alert {
    name: string;
    message: string;
    color: string;
    icon?: string;
    allowCustomNote: boolean;
    /** Consumers (Field App) must capture an acknowledgment before dismissing this alert. Set only on Tag alerts, from the label's AlertOptions. */
    requireAcknowledgement?: boolean;
    important?: boolean;
    type?: AlertType;
    priority?: AlertPriority;
}


export const AlertDisplayEntities = [
    // Account, Site, Contact/Employee, Job/Stage, Opportunity & Quote.
    ActivityEntityName.Account,
    ActivityEntityName.Site,
    ActivityEntityName.ContactEmployee,
    ActivityEntityName.Job,
    ActivityEntityName.WorkOrder,
    ActivityEntityName.Opportunity,
    ActivityEntityName.Quote,
];